import { render, staticRenderFns } from "./CostDetailManagement.vue?vue&type=template&id=0c4ab65e&scoped=true"
import script from "./CostDetailManagement.vue?vue&type=script&lang=js"
export * from "./CostDetailManagement.vue?vue&type=script&lang=js"
import style0 from "./CostDetailManagement.vue?vue&type=style&index=0&id=0c4ab65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ab65e",
  null
  
)

export default component.exports